import { ButtonHTMLAttributes, forwardRef } from 'react';

import { cn } from '../../libs/utils';

export interface BaseButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  loadingColor: string;
  isLoading?: boolean;
}

export const BaseButton = forwardRef<HTMLButtonElement, BaseButtonProps>(({ className, children, isLoading, disabled, loadingColor, ...props }, ref) => {
  return (
    <button
      className={cn(className, {
        'relative text-transparent disabled:text-transparent': isLoading
      })}
      ref={ref}
      disabled={disabled || isLoading}
      {...props}
    >
      {children}
    </button>
  );
});

BaseButton.displayName = 'BaseButton';
